import { useMemo } from 'react';
import { AuditionPhase } from 'shared/enums/AuditionPhase';
import { AuditionStatus } from 'shared/enums/AuditionStatus';
import { useSetHeaderBack, useSetHeaderTitle } from 'shared/hooks/useSetHeader';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';
import PastSelfTapesItem from './PastSelfTapesItem/PastSelfTapesItem';
import { AuditionItemsContainer, Content, ContentItemContainer, Heading, MainContainer } from './PastSelfTapes.styles';
import { useParams } from 'react-router-dom';
import PastSelfTape from './PastSelfTape/PastSelfTape';
import { Backdrop } from '@room-match/shared-ui-components';

const { getAuditionSchedules } = auditionScheduleService();
const PastSelfTapes = () => {
  const { data, isLoading } = getAuditionSchedules({
    phase: AuditionPhase.SELF_TAPES,
  });

  const { auditionScheduleId } = useParams() as { auditionScheduleId: string };

  useSetHeaderBack(false);
  useSetHeaderTitle(`Past Self Tapes`);

  const getData = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return data
        ? data.pages.filter((v, index) => index === 0).map((i) => i.data.talent_audition_schedules_connection.nodes)
        : undefined;
    }
  }, [data, isLoading]);

  if (isLoading) return <Backdrop isLoading={true} />;
  return auditionScheduleId ? (
    <PastSelfTape auditionScheduleId={auditionScheduleId} />
  ) : (
    <MainContainer>
      <Content>
        <ContentItemContainer>
          <Heading>Previous Self Tape Submissions</Heading>
          <AuditionItemsContainer>
            {getData ? getData[0].map((i) => <PastSelfTapesItem data={i} status={i.status} />) : 'No Data Available'}
          </AuditionItemsContainer>
        </ContentItemContainer>
      </Content>
    </MainContainer>
  );
};

export default PastSelfTapes;
